import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Page, PageHeader } from "@/app/Page";
import { RouteTabs } from "@/app/RouteTabs";

export const Route = createFileRoute("/$workspace/$project/settings")({
  staticData: { title: "Settings" },
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <Page>
      <PageHeader title="Settings" description="Variables, domains, environments, people, guv.yaml and webhooks." />
      <RouteTabs
        className="mb-8"
        items={[
          { to: "/$workspace/$project/settings/variables", label: "Variables & secrets" },
          { to: "/$workspace/$project/settings/domains", label: "Domains" },
          { to: "/$workspace/$project/settings/environments", label: "Environments" },
          { to: "/$workspace/$project/settings/members", label: "Members" },
          { to: "/$workspace/$project/settings/manifest", label: "Manifest" },
          { to: "/$workspace/$project/settings/webhooks", label: "Webhooks" },
          { to: "/$workspace/$project/settings/danger", label: "Danger zone" },
        ]}
      />
      <Outlet />
    </Page>
  );
}
